import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class ButtonHandler {
	constructor(nextButton, signupButton, guestCamButton, ctaButton) {
		helper.triggerEvent(window, Events.START_ACTION);

		helper.addEventListener(nextButton, 'click', (evt) => {
			// eslint-disable-next-line no-undef
			evt.preventDefault();
			helper.triggerEvent(window, Events.SHOW_NEXT_GIRL);
		});

		helper.addEventListener(signupButton, 'click', (evt) => {
			// eslint-disable-next-line no-undef
			evt.preventDefault();
			helper.triggerEvent(window, Events.CREATE_SIGNUP);
		});
		helper.addEventListener(ctaButton, 'click', (evt) => {
			// eslint-disable-next-line no-undef
			evt.preventDefault();
			helper.triggerEvent(window, Events.CREATE_SIGNUP);
		});

		helper.addEventListener(guestCamButton, 'click', (evt) => {
			// eslint-disable-next-line no-undef
			evt.preventDefault();
			helper.triggerEvent(window, Events.START_GUEST_CAM);
		});

		// Delegated click handling, so that we only have one click handler
		helper.addEventListener(helper.$('#information'), 'click', function (evt) {
			if (evt.target.matches('.paytour, .paytour *')) {
				evt.preventDefault();
				helper.triggerEvent(window, Events.CREATE_SIGNUP);
			}
		});
	}
}
